// note: this code is in es5 so that developers do not have to set up transpilation for their client bundle
/* eslint-disable */
'use strict';

var path = require('path-browserify');

var URL = require('url-parse');

var ASSET_URL = process.env.ASSET_URL;
var ASSET_HASH = process.env.ASSET_HASH;

var baseUrlObj = {};

if (!ASSET_URL) {
  baseUrlObj = new URL('http://'.concat(process.env.SERVER_HOSTNAME, ':').concat(process.env.SERVER_PORT), true);
} else {
  var url = '';

  if (/\/$/.test(ASSET_URL)) {
    url = ASSET_URL;
  } else {
    url = ''.concat(ASSET_URL, '/');
  }

  baseUrlObj = new URL(url, true);
}

function revPath(file, hash) {
  var ext = path.extname(file);

  return path.join(path.dirname(file), path.basename(file, ext) + '-' + hash + ext);
}

function assetUrl(inpFile) {
  var baseUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : baseUrlObj.href;
  var hash = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ASSET_HASH;
  var relativeUrl = inpFile;

  if (hash) {
    relativeUrl = revPath(inpFile, hash);
  }

  var urlObj = new URL(relativeUrl, baseUrl, true);
  return urlObj.href;
}

module.exports = assetUrl;
/* eslint-enable */
